require('./mortgageRequestHolderEconomic.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const { cloneDeep, every, values, contains, get, isEmpty, find } = require('lodash');
const Immutable = require('immutable');

// @ utilities
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');
const { getMultiples, getTexts, getTextDescription, getTextLinkDescription } = require('utilities/dragNDropUpload');

// @ commons
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { ContentBox } = require('commonsComponents/contentBox');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { InputSafe } = require('commonsComponents/inputSafe');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { DragNDropUpload } = require('commonsComponents/dragNDropUpload');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const classNames = require('classnames');

// @ components
const { AmountInput } = require('commonsComponents/amountInput');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { MortgageEconomicFormHasMortgage } = require('./mortgageRequestHolderEconomicFormHasMortgage/mortgageRequestHolderEconomicFormHasMortgage');
const MortgageRequestHolderEconomicOtherLoans = require('./mortgageRequestHolderEconomicOtherLoans/mortgageRequestHolderEconomicOtherLoans');
const { LoadingSection } = require('commonsComponents/loadingSection');
const MortgageRequestGoToDocCenter = require('../mortgageRequestGoToDocCenter/mortgageRequestGoToDocCenter');
const { MortgageRequestManagerDocumentation } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerDocumentation/mortgageRequestManagerDocumentation');

// @ actions
const holderEconomicActions = require('actions/mortgageRequest/mortgageRequestHolderEconomic');
const mortgageRequestWorkData = require('actions/mortgageRequest/mortgageRequestWorkData');
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');

// @ helpers
const { formatCurrency } = require('utilities/currencyHelper');
const { stringToBoolean } = require('utilities/stringHelper');

// @ constants
const { SEDE_ELECTRONICA_AGENCIA_TRIBUTARIA_SPANISH, SEDE_ELECTRONICA_AGENCIA_TRIBUTARIA_ENGLISH } = require('constants/links');
const { HOUSING_OWNERSHIP_TYPE, EMPLOYMENT_SITUATION, DOCUMENTS_STATUS, OTHER_LOANS_FILE_TYPES } = require('constants/mortgageRequestHolderData');
const currencyFormatted = formatCurrency('EUR');
const { IRPF100_CLI, IRPF130, IRPF_DIGITAL_FILE_TYPE, IRPF_CSV_TYPE } = require('constants/mortgageRequestDocumentsTypes.js');
const mortgageRequestPanelStates = require('constants/mortgageRequestPanelStates');
const { DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT, DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE, DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME, DRAG_N_DROP_UPLOAD_MAX_SIZE, DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES, DRAG_N_DROP_UPLOAD_TITLE, DRAG_N_DROP_UPLOAD_ERROR_MESSAGE } = require('constants/commonsComponents');
const { HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER } = require('constants/flagBasedFeatures');

// @ track processes
const { PROC_CHANGE_ECONOMIC_DATA } = require('constants/mortgageRequestProcesses');

const validMessages = {
    isRequired: formatText('mortgageRequestCommons-defaultFormError'),
    codeCSVDigits: formatText('mortgageRequestHolderEconomic-codeCSVDigits')
};
const multiples = getMultiples(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
const texts = getTexts(DRAG_N_DROP_UPLOAD_AMOUNT_FILES_LIMIT, DRAG_N_DROP_UPLOAD_MAX_LENGTH_FILE_NAME, DRAG_N_DROP_UPLOAD_MAX_SIZE, multiples, DRAG_N_DROP_UPLOAD_VALID_TYPES_FILES);
const textDescription = getTextDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
const textLinkDescription = getTextLinkDescription(DRAG_N_DROP_UPLOAD_IS_MULTIPLE_DEFAULT_VALUE);
let lastPosition = '';

class MortgageRequestHolderEconomic extends React.Component {
    constructor(props) {
        super(props);

        const { workData } = this.props;

        this.state = {
            codigoCSV: '',
            codigoCSVValid: true,
            codigoPersona: '',
            cuotaMensualAlquiler: 0,
            cuotaMensualOtroPrestamo: 0,
            cuotaMensualPrestamoHipotecario: 0,
            cuotaMensualPrestamoHipotecarioOrigin: 0,
            datosEconomicosDeclarados: '',
            datosObservados: '',
            importeTotalpendienteOtraHipoteca: 0,
            importeTotalpendienteOtraHipotecaOrigin: 0,
            importeTotalpendienteOtraHipotecaValid: false,
            importeTotalpendienteOtraHipotecaDisabled: true,
            ingresosNetos: 0,
            ingresosNetosValid: true,
            modelo130: 0,
            numeroDocumento: '',
            quiereCancelarOtraHipoteca: false,
            quiereCancelarOtraHipotecaOrigin: false,
            quiereCancelarOtraHipotecaValid: false,
            regimenInmueble: '',
            regimenInmuebleValid: true,
            tieneOtraHipoteca: false,
            tipoDocumentoIdentidad: '',
            tipoTrabajador: workData.get('situacionLaboral'),
            isFetching: false,
            irpfType: IRPF_DIGITAL_FILE_TYPE,
            irpf: 0,
            immAnotherLoan: Immutable.fromJS({}),
            isEditingOtherLoans: false
        };

        this.language = getLanguage();

        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeRegimenInmueble = this.handleChangeRegimenInmueble.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.buildSectionAutonomoContent = this.buildSectionAutonomoContent.bind(this);
        this.buildSectionAutonomoInfo = this.buildSectionAutonomoInfo.bind(this);
        this.setFieldValue = this.setFieldValue.bind(this);
        this.isValidCurrency = this.isValidCurrency.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.handleOnChangeFile = this.handleOnChangeFile.bind(this);
        this.handleFormhasHipotecas = this.handleFormhasHipotecas.bind(this);
        this.handleChangeIrpfType = this.handleChangeIrpfType.bind(this);
        this.handleCancelarPrestamosAnteriores = this.handleCancelarPrestamosAnteriores.bind(this);
        this.hideCuotaMensual = this.hideCuotaMensual.bind(this);
        this.getDocumentData = this.getDocumentData.bind(this);
        this.handleCancelChangeEconomicData = this.handleCancelChangeEconomicData.bind(this);
        this.handleAddOtherLoan = this.handleAddOtherLoan.bind(this);
        this.handleEditAnotherLoan = this.handleEditAnotherLoan.bind(this);
        this.handleOnDownloadFile = this.handleOnDownloadFile.bind(this);
        this.checkFile = this.checkFile.bind(this);
        this.checkHolderEconomic = this.checkHolderEconomic.bind(this);
        this.checkHolderWorkData = this.checkHolderWorkData.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        recordProcess(PROC_CHANGE_ECONOMIC_DATA, PROC_START);

        const { mortgageRequestState, requestHolderEconomic, requestHolderWork, summaryDocsState, requestOtherLoans } = this.props;

        const docData = this.getDocumentData();
        const idExpediente = mortgageRequestState.get('idExpediente');

        if (idExpediente) {
            requestHolderWork(docData.tipoDocumentoIdentidad, docData.numeroDocumento);
            requestHolderEconomic(docData.tipoDocumentoIdentidad, docData.numeroDocumento);
            requestOtherLoans(docData.tipoDocumentoIdentidad, docData.numeroDocumento);
        }

        if (!summaryDocsState.get('documentsRequested')) {
            const { requestSummaryDocumentation } = this.props;
            requestSummaryDocumentation();
        } else {
            this.checkFile();
        }
    }

    componentDidUpdate(prevProps) {
        this.checkHolderEconomic(prevProps);
        this.checkHolderWorkData(prevProps);
        if (
            (this.props.summaryDocsState !== prevProps.summaryDocsState) &&
            (this.props.summaryDocsState.get('isFetching') !==
            prevProps.summaryDocsState.get('isFetching')) && !this.props.summaryDocsState.get('isFetching')
        ) {
            this.checkFile();
        }

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        this.props.resetHolderEconomicState();
        this.props.resetWorkDataState();
    }

    checkHolderWorkData(prevProps) {
        if (
            (this.props.workData !== prevProps.workData) &&
            (this.props.workData.get('isFetching') !==
            prevProps.workData.get('isFetching')) && !this.props.workData.get('isFetching')
        ) {
            this.setState({
                tipoTrabajador: this.props.workData.get('situacionLaboral')
            });
        }
    }

    checkHolderEconomic(prevProps) {
        if (this.props.holderEconomic !== prevProps.holderEconomic) {
            const { obcd, holderEconomic: stateData } = this.props;

            const docData = this.getDocumentData();
            const immOtherLoans = stateData.get('otherLoans');
            const tieneOtraHipoteca = immOtherLoans.size > 0 || stateData.get('cuotaMensualOtroPrestamo') > 0 || stateData.get('tieneOtraHipoteca');

            this.setState({
                codigoCSV: stateData.get('codigoCSV'),
                codigoPersona: obcd,
                cuotaMensualAlquiler: stateData.get('cuotaMensualAlquiler'),
                cuotaMensualOtroPrestamo: stateData.get('cuotaMensualOtroPrestamo'),
                cuotaMensualPrestamoHipotecario: stateData.get('cuotaMensualPrestamoHipotecario'),
                cuotaMensualPrestamoHipotecarioOrigin: stateData.get('cuotaMensualPrestamoHipotecario'),
                datosEconomicosDeclarados: stateData.get('datosEconomicosDeclarados'),
                datosObservados: stateData.get('datosObservados'),
                importeTotalpendienteOtraHipoteca: stateData.get('importeTotalpendienteOtraHipoteca'),
                importeTotalpendienteOtraHipotecaOrigin: stateData.get('importeTotalpendienteOtraHipoteca'),
                ingresosNetos: stateData.get('ingresosNetos'),
                modelo130: [],
                numeroDocumento: docData.numeroDocumento,
                quiereCancelarOtraHipoteca: stateData.get('quiereCancelarOtraHipoteca'),
                importeTotalpendienteOtraHipotecaDisabled: !stateData.get('quiereCancelarOtraHipoteca'),
                regimenInmueble: stateData.get('regimenInmueble'),
                tieneOtraHipoteca,
                tipoDocumentoIdentidad: docData.tipoDocumentoIdentidad,
                isFetching: stateData.get('isFetching'),
                irpf: [],
                quiereCancelarOtraHipotecaOrigin: stateData.get('quiereCancelarOtraHipoteca'),
                immOtherLoans,
                tieneOtraHipotecaValid: true
            });
        }
    }

    getDocumentData() {
        const { holderId } = this.props;
        const docData = holderId.split('-');
        return {
            tipoDocumentoIdentidad: docData[0],
            numeroDocumento: docData[1],
        }
    }

    setFieldValue(value, evt) {
        const { name } = evt.target;
        this.setState({ [name]: value, });
        this.isValidCurrency(name, value);
    }

    buildAddAnotherLoanButton() {
        const error = !this.state.isEditingOtherLoans && !this.state.tieneOtraHipotecaValid;
        const errorMessage = formatText('mortgageRequestHolderEconomic-otherLoansFormErrorNoLoans');
        const errorMsg = error && (
            <p className="mortgage-request-holder-economic-has-mortgage__error">{errorMessage}</p>
        );

        return (
            <div className="mortgage-request-holder-economic-has-mortgage__add-link">
                <OKButton
                    modifier="ghost"
                    leftIcon="icon-agregar"
                    onClick={() => this.handleAddOtherLoan(true)}
                >
                    {formatText('mortgageRequestHolderEconomic-otherLoansFormAddButtonLabel')}
                </OKButton>
                {errorMsg}
            </div>
        );
    }

    buildAnotherLoanForm() {
        const { summaryDocsState } = this.props;
        const { immAnotherLoan } = this.state;

        const immDocument = summaryDocsState.get('data').find(immDocument => immDocument.get('idPrestamo') === immAnotherLoan.get('id') &&
            immDocument.get('tipoDocumento') === immAnotherLoan.get('documentType') &&
            immDocument.get('numeroDocumento') === immAnotherLoan.get('documentNumber') &&
            immDocument.get('tipoDocumentoId') === OTHER_LOANS_FILE_TYPES[immAnotherLoan.get('type')]
        );

        return (
            <MortgageEconomicFormHasMortgage
                holderDocument={this.getDocumentData()}
                onEditStateChange={this.handleAddOtherLoan}
                immAnotherLoan={immAnotherLoan}
                onDownload={this.handleOnDownloadFile}
                immDocument={immDocument}
            />
        );
    }

    buildOtherLoansContent() {
        const { dataProprietors } = this.props;
        const personalData = dataProprietors.get('personalData');
        const hasOperationProcessId = personalData.some(person => person?.operationProcessId);
        return (
            <div className="row">
                <div className="col-md-12 mortgage-request-holder-economic__intro">
                    <br />
                    <RadioButtonGroup
                        name="tieneOtraHipoteca"
                        idPrefix="changetieneOtraHipoteca"
                        selectedValue={this.state.tieneOtraHipoteca}
                        onChange={this.handleFormhasHipotecas}
                        isHorizontal
                        className="account-cancel-chequebook-step__radio-group"
                        label={formatText('mortgageRequestHolderEconomic-labelTieneOtroPrestamoHipotecario')}
                    >
                        <RadioButton
                            label={formatText('mortgageRequestHolderEconomic-labelSiTengoPrestamoHipotecario')}
                            inline={false}
                            value
                            className="block-step__radio"
                            disabled={ hasOperationProcessId }
                        />
                        <RadioButton
                            label={formatText('mortgageRequestHolderEconomic-labelNoTengoPrestamoHipotecario')}
                            inline={false}
                            value={false}
                            className="block-step__radio"
                            disabled={ hasOperationProcessId }
                        />
                    </RadioButtonGroup>
                </div>
            </div>
        )
    }

    buildSectionAutonomoContent(isDisabled, isFetching) {

        return (
            <div className="mortgage-request-holder-economic__section">
                <hr />
                <h2>{formatText('mortgageRequestHolderEconomic-titleModel130')}</h2>
                <p>{formatText('mortgageRequestHolderEconomic-infoModel130')}</p>

                <DragNDropUpload
                    idName="modelo130"
                    onChange={this.handleOnChangeFile}
                    loading={isFetching}
                    debug={false}
                    ammountFiles={this.state.modelo130.length}
                    fileText="Modelo130"
                    overwriteFile
                    disabled={isDisabled}
                    onDownload={() => this.handleOnDownloadFile(IRPF130)}
                    texts={texts}
                    title={DRAG_N_DROP_UPLOAD_TITLE}
                    textDescription={textDescription}
                    textLinkDescription={textLinkDescription}
                    errorMessage={DRAG_N_DROP_UPLOAD_ERROR_MESSAGE}
                />
            </div>
        );
    }

    buildSectionAutonomoInfo() {
        return (
            <ContentBox customClassName="mortgage-request-holder-economic__margin">
                <h2 className="mortgage-request-holder-economic__block-title">
                    {formatText('mortgageRequestHolderEconomic-titleModel130Info')}
                </h2>
                <p>{formatText('mortgageRequestHolderEconomic-infoModel130Info')}</p>
                <OKLink
                    modifier="editorial"
                    name={'btnSEAT'}
                    to={SEDE_ELECTRONICA_AGENCIA_TRIBUTARIA_SPANISH}
                    target="_blank"
                >
                    {formatText('mortgageRequestHolderEconomic-linkSEAT')}
                </OKLink>
            </ContentBox>
        );
    }

    buildIrpfSection() {
        const { docCenterState, holderEconomicEdit, mortgageRequestState } = this.props;
        const isFetchingIRPF = docCenterState.getIn(['isFetching', IRPF100_CLI]) || holderEconomicEdit.get('isFetchingIRPF');
        const currentState = mortgageRequestState.get('estado');
        const isApprovedDataProprietor = contains(mortgageRequestPanelStates.APPROVED_STATES_DATA_PROPRIETOR, currentState);

        let content = '';

        const radioButtons = (
            <RadioButtonGroup
                name="IrpfType"
                idPrefix="changeIrpfType"
                selectedValue={this.state.irpfType}
                onChange={this.handleChangeIrpfType}
                isHorizontal
                className="account-cancel-chequebook-step__radio-group"
            >
                <RadioButton
                    label={formatText('mortgageRequestHolderEconomic-IRPFLabel')}
                    inline
                    value={IRPF_DIGITAL_FILE_TYPE}
                    className="block-step__radio"
                />
                <RadioButton
                    label={formatText('mortgageRequestHolderEconomic-CSVLabel')}
                    inline
                    value={IRPF_CSV_TYPE}
                    className="block-step__radio"
                />
            </RadioButtonGroup>
        );

        const irpfDigital = (
            <div>
                <p className="mortgage-request-holder-economic__section__irpf-subtitle">{formatText('mortgageRequestHolderEconomic-infoIrpf')}</p>
                <DragNDropUpload
                    onChange={this.handleOnChangeFile}
                    idName="irpf"
                    fileText="IRPF"
                    title="dndIRPF"
                    loading={isFetchingIRPF}
                    debug={false}
                    ammountFiles={this.state.irpf.length}
                    overwriteFile
                    disabled={isApprovedDataProprietor}
                    onDownload={() => this.handleOnDownloadFile(IRPF100_CLI)}
                    texts={texts}
                    textDescription={textDescription}
                    textLinkDescription={textLinkDescription}
                    errorMessage={DRAG_N_DROP_UPLOAD_ERROR_MESSAGE}
                />
            </div>
        );

        const irpfCSV = (
            <div>
                <p className="mortgage-request-holder-economic__section__irpf-subtitle">{formatText('mortgageRequestHolderEconomic-infoIrpfCSV')}</p>
                <div className="row">
                    <div className="col-md-6">
                        <InputSafe
                            label={formatText('mortgageRequestHolderEconomic-labelCodeCSV')}
                            name="codigoCSV"
                            type="text"
                            value={this.state.codigoCSV}
                            onBlur={this.handleBlur}
                            onChange={this.handleChange}
                            errorState={!this.state.codigoCSVValid}
                            errorMessage={validMessages.codeCSVDigits}
                            maxLength={16}
                            disabled={isApprovedDataProprietor}
                        />
                    </div>
                </div>
            </div>
        );

        content = this.state.irpfType === IRPF_DIGITAL_FILE_TYPE ? irpfDigital : irpfCSV;

        return (
            <div className="mortgage-request-holder-economic__section__irpf-container">
                {radioButtons}
                {content}
            </div>
        );
    }

    buildTooltip() {
        return (
            <OKTooltip
                content="mortgageRequestHolderEconomic-tooltipCuotaMensualAlquiler"
                offset={[0, -15]}
            />
        );
    }

    checkFile() {
        const { summaryDocsState } = this.props;
        const docData = this.getDocumentData();
        const docsSummary = summaryDocsState.get('data').toJS();
        const fileOptionList = [IRPF100_CLI, IRPF130];

        const docs = docsSummary.filter(doc => {
            const documentDataStatus = get(doc, 'estado', DOCUMENTS_STATUS.NONE) || DOCUMENTS_STATUS.NONE;

            const isHolderDoc = (
                doc.tipoDocumento === docData.tipoDocumentoIdentidad &&
                doc.numeroDocumento === docData.numeroDocumento
            );
            const isEconomicDoc = find(fileOptionList, (op) => { return op === doc.tipoDocumentoId });

            const isDocStateOk = (
                documentDataStatus !== DOCUMENTS_STATUS.PEND_APORTAR &&
                documentDataStatus !== DOCUMENTS_STATUS.NONE
            );

            return isHolderDoc && isEconomicDoc && isDocStateOk;
        });

        this.setState({
            irpf: docs.filter(d => d.tipoDocumentoId === IRPF100_CLI),
            modelo130: docs.filter(d => d.tipoDocumentoId === IRPF130),
        });
    }

    handleAddOtherLoan(isEditingOtherLoans, shouldRequestDocumentation) {
        this.setState({
            isEditingOtherLoans,
            immAnotherLoan: Immutable.fromJS({}),
            shouldRequestDocumentation
        });
    }

    handleBlur(evt) {
        const field = evt.target;
        const value = field.value.trim();
        this.setState({ [field.name]: value });
    }

    handleCancelChangeEconomicData(evt) {
        evt.preventDefault();
        recordProcess(PROC_CHANGE_ECONOMIC_DATA, PROC_CANCEL);
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleCancelarPrestamosAnteriores(value) {
        let importeTotalpendienteOtraHipotecaOrigin = this.state.importeTotalpendienteOtraHipotecaOrigin;
        const event = stringToBoolean(value);
        const data = {
            quiereCancelarOtraHipoteca: event,
            quiereCancelarOtraHipotecaValid: false
        };

        if (event) {
            data.importeTotalpendienteOtraHipotecaValid = true;
            data.importeTotalpendienteOtraHipotecaDisabled = false;
        } else {
            data.importeTotalpendienteOtraHipoteca = importeTotalpendienteOtraHipotecaOrigin;
            data.importeTotalpendienteOtraHipotecaDisabled = true;
            data.importeTotalpendienteOtraHipotecaValid = false;
        }

        this.setState(data);
    }

    handleChange(evt) {
        const { name, value } = evt.target;
        let nonNumericRegex = /[^0-9]+/g;
        switch (name) {
            case 'phoneCode':
                this.setState({ [name]: '+' + value.replace(nonNumericRegex, '').trim() });
                break;
            case 'phoneNumber':
                nonNumericRegex = /^[^67]|[^\d]+/g;
                this.setState({ [name]: value.replace(nonNumericRegex, '').trim() });
                break;
            case 'postalCode':
            case 'numberStreet':
                this.setState({ [name]: evt.target.value.replace(nonNumericRegex, '').trim() });
                break;
            default:
                this.setState({ [name]: value });
        }
    }

    handleChangeRegimenInmueble(option) {
        this.setState({ regimenInmueble: option.value });
        if (this.hideCuotaMensual(option.value)) {
            this.setState({ cuotaMensualAlquiler: 0 })
        }

    }

    handleEditAnotherLoan(immAnotherLoan) {
        this.setState({
            isEditingOtherLoans: true,
            immAnotherLoan
        });
    }

    handleFormhasHipotecas(value) {
        const event = stringToBoolean(value);
        const data = {
            tieneOtraHipoteca: event
        };

        if (!event) {
            const { importeTotalpendienteOtraHipotecaOrigin, quiereCancelarOtraHipotecaOrigin, cuotaMensualPrestamoHipotecarioOrigin } = this.state;

            data.importeTotalpendienteOtraHipoteca = importeTotalpendienteOtraHipotecaOrigin;
            data.quiereCancelarOtraHipoteca = quiereCancelarOtraHipotecaOrigin;
            data.cuotaMensualPrestamoHipotecario = cuotaMensualPrestamoHipotecarioOrigin;
            data.importeTotalpendienteOtraHipotecaValid = false;
            data.importeTotalpendienteOtraHipotecaDisabled = true;
        }

        this.setState(data);
    }

    handleChangeIrpfType(value) {
        this.setState({ irpfType: value })
    }

    handleOnChangeFile(fileState) {
        const { addFile } = this.props;
        if (fileState) {
            if (!fileState.error) {
                addFile(fileState);
            }
        }
    }

    handleOnDownloadFile(fileType, loanId) {
        const docData = this.getDocumentData();

        this.props.requestDocuments({
            documentType: fileType,
            idDocumentType: docData.tipoDocumentoIdentidad,
            idDocumentNumber: docData.numeroDocumento,
            loanId
        });
    }

    handleSave(evt, confirm) {
        evt.preventDefault();

        const { editHolderEconomic, holderNum, mortgageRequestState, editHolderEconomicIRPF, editHolderEconomic130, history } = this.props;
        const proprietorNumValue = parseInt(holderNum, 10);

        if (this.validateFields()) {
            const data = cloneDeep(this.state);
            data.confirmada = confirm;
            editHolderEconomic(data, proprietorNumValue, history);

            const docData = this.getDocumentData(data);

            if (this.props.holderEconomicEdit.hasIn(['files', 'irpf'])) {
                editHolderEconomicIRPF(mortgageRequestState.get('idExpediente'), IRPF100_CLI, docData.numeroDocumento, docData.tipoDocumentoIdentidad);
            }
            if (this.props.holderEconomicEdit.hasIn(['files', 'modelo130'])) {
                editHolderEconomic130(mortgageRequestState.get('idExpediente'), IRPF130, docData.numeroDocumento, docData.tipoDocumentoIdentidad);
            }
        }

    }

    handleScroll() {
        if (window.innerWidth + 17 >= 768 && window.innerHeight > 650) {
            const panelLeft = $("#mortgageRequestHolderEconomicPanelLeft");
            const panelRight = $("#mortgageRequestHolderEconomicPanelRight");
            const panelLeftHeight = panelLeft.height();
            const panelRightHeight = panelRight.height();
            const scroll = window.pageYOffset;
            const topbarHeight = $(".openbank-topbar").height() + $(".private-menu").height();
            const styles = {};
            let currentPosition = '';

            if (scroll > panelLeft.offset().top - topbarHeight) {
                const leftPositionPanelRight = panelLeft.outerWidth();

                if (scroll + panelRightHeight + topbarHeight >= panelLeft.offset().top + panelLeftHeight) {
                    currentPosition = 'absolute';
                    if (lastPosition != currentPosition) {
                        styles.position = 'absolute';
                        styles.top = `${panelLeftHeight - panelRightHeight + 5}px`;
                        styles.left = `${leftPositionPanelRight - 15}px`;
                    }
                } else {
                    currentPosition = 'fixed';

                    if (lastPosition != currentPosition) {
                        styles.position = 'fixed';
                        styles.top = `${topbarHeight}px`;
                        styles.left = `${leftPositionPanelRight + $("#mortgageRequestHolderEconomicBody").offset().left - 15}px`;
                        styles.width = `${panelRight.outerWidth()}px`;
                    }
                }
            } else {
                currentPosition = 'relative';
                if (lastPosition != currentPosition) {
                    styles.position = 'relative';
                    styles.top = '';
                    styles.left = '';
                }
            }

            isEmpty(styles) || $(panelRight).css(styles);
            lastPosition = currentPosition;
        }
    }

    hideCuotaMensual(regimenInmueble) {
        return (regimenInmueble !== HOUSING_OWNERSHIP_TYPE.ALQUILER);
    }

    isValidCurrency(name, value) {
        const thisName = name + 'Valid';
        let isValid = true;
        if (value === 0) isValid = false;
        this.setState({
            [thisName]: isValid,
        });
    }

    validateFields() {
        const { holderEconomic, immFlagBasedFeatures } = this.props;
        const ffShowDocument = immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER);
        const { ingresosNetos, codigoCSV, regimenInmueble, tieneOtraHipoteca } = this.state;
        const otherLoans = holderEconomic.get('otherLoans');
        const newState = {
            ingresosNetosValid: ingresosNetos !== 0,
            codigoCSVValid: !codigoCSV || codigoCSV.length === 16 || ffShowDocument,
            regimenInmuebleValid: regimenInmueble !== 'UNKNOWN',
            tieneOtraHipotecaValid: !tieneOtraHipoteca || otherLoans.count() > 0
        };
        this.setState(newState);
        return every(values(newState));
    }

    buildManagerDocumentation() {
        const { holdersDataValidation, holderNum } = this.props;
        const proprietorNumValue = parseInt(holderNum, 10);
        const holderKey = proprietorNumValue === 2 ? 'isCoHolder' : 'isHolder';
        const isCompleted = holdersDataValidation.getIn([holderKey, 'isCompleted']);
        return isCompleted && (
            <MortgageRequestManagerDocumentation />
        )
    }

    render() {
        const { dataProprietors } = this.props;
        const { numeroDocumento, tipoTrabajador } = this.state;
        if (tipoTrabajador === "UNKNOWN" || numeroDocumento === '') {
            return <LoadingSection />;
        }

        const sedeElectronicaAgenciaTributariaLink = this.language === 'en' ? SEDE_ELECTRONICA_AGENCIA_TRIBUTARIA_ENGLISH
            : SEDE_ELECTRONICA_AGENCIA_TRIBUTARIA_SPANISH

        const { holderEconomicEdit, mortgageRequestState, docCenterState, deleteOtherLoan, summaryDocsState, requestDocuments, holderEconomic, requestSummaryDocumentation, holderNum } = this.props;

        const currentState = mortgageRequestState.get('estado');
        const isApprovedDataProprietor = contains(mortgageRequestPanelStates.APPROVED_STATES_DATA_PROPRIETOR, currentState);

        const irpfSection = this.buildIrpfSection();

        const helpToolTipCuotaMensualAlquiler = this.buildTooltip();

        let holder;

        if (parseInt(holderNum, 10) === 1) {
            holder = 'First';
        } else {
            holder = 'Second';
        }

        const title = formatText(`mortgageRequestHolderEconomic-title${holder}`);
        const subtitle = formatText('mortgageRequestHolderEconomic-subtitle');
        const {immFlagBasedFeatures} = this.props;
        const ffShowDocument = !(immFlagBasedFeatures.get(HIDE_INDIVIDUAL_UPLOAD_DOCUMENTS_HOLDER));
        const ffClassHideDoc = ffShowDocument ? 'col-md-5' : "col-md-9";
        const personalData = dataProprietors.get('personalData');
        const hasOperationProcessId = personalData.some(person => person?.operationProcessId);

        /**
         * TODO: Translation
         */
        const regimenInmuebleOptions = [
            { label: `${formatText('mortgageRequestHolderEconomic-rent')}`, value: HOUSING_OWNERSHIP_TYPE.ALQUILER },
            { label: `${formatText('mortgageRequestHolderEconomic-familiar')}`, value: HOUSING_OWNERSHIP_TYPE.FAMILIAR },
            { label: `${formatText('mortgageRequestHolderEconomic-mortgagedProperty')}`, value: HOUSING_OWNERSHIP_TYPE.PROPIEDAD_HIPOTECADA },
            { label: `${formatText('mortgageRequestHolderEconomic-propertyWithoutLoads')}`, value: HOUSING_OWNERSHIP_TYPE.PROPIEDAD_SIN_CARGAS },
            { label: `${formatText('mortgageRequestHolderEconomic-others')}`, value: HOUSING_OWNERSHIP_TYPE.OTROS }
        ];
        let saving = holderEconomicEdit.get('isFetching');

        let isBuildAutonomoContent, isBuildAutonomoInfo, otherLoansContent, anotherLoanContent, inforAnotherLoans;

        let saveDisabled = this.state.isEditingOtherLoans;

        if(ffShowDocument) {
            if (this.state.tipoTrabajador === EMPLOYMENT_SITUATION.AUTONOMO) {
                const isFetching130 = docCenterState.getIn(['isFetching', IRPF130]) || holderEconomicEdit.get('isFetching130');
                isBuildAutonomoContent = this.buildSectionAutonomoContent(isApprovedDataProprietor, isFetching130);
                isBuildAutonomoInfo = this.buildSectionAutonomoInfo();

                if (this.state.modelo130.length === 0 && !this.props.holderEconomicEdit.hasIn(['files', 'modelo130'])) {
                    saveDisabled = true;
                }
            }
        }

        const montlyFeeContainerClasses = classNames(
            'mortgage-request-holder-economic__section',
            {
                'hide': this.hideCuotaMensual(this.state.regimenInmueble)
            }
        );

        if (holderEconomic.get('isFetchingOtherLoans')) {
            otherLoansContent = <LoadingSection />;
        } else {
            if (this.state.tieneOtraHipoteca) {
                otherLoansContent = (
                    <MortgageRequestHolderEconomicOtherLoans
                        immOtherLoans={this.state.immOtherLoans}
                        immSummaryDocs={summaryDocsState}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        requestDocuments={requestDocuments}
                        deleteOtherLoan={(params) => deleteOtherLoan(params, this.props.history)}
                        holderEconomic={holderEconomic}
                        onEditAnotherLoan={this.handleEditAnotherLoan}
                        onDownload={this.handleOnDownloadFile}
                        requestSummaryDocumentation={requestSummaryDocumentation}
                        shouldRequestDocumentation={this.state.shouldRequestDocumentation}
                    />
                );

                inforAnotherLoans = <FormattedText value="mortgageRequestHolderEconomic-infoAnotherLoans" />;
                if (this.state.isEditingOtherLoans) {
                    anotherLoanContent = this.buildAnotherLoanForm();
                } else {
                    anotherLoanContent = this.buildAddAnotherLoanButton();
                }
            } else {
                otherLoansContent = this.buildOtherLoansContent();
            }
        }

        return (
            <div id="mortgageRequestHolderEconomicBody" className="mortgage-request-holder-economic">
                <div className="row">
                    <div id="mortgageRequestHolderEconomicPanelLeft" className="col-md-8">
                        <ContentBox>
                            <div className="mortgage-request-holder-economic__title" >
                                <OKBoxTitle value={title} children={subtitle} size="medium" />
                            </div>
                            <div className="mortgage-request-holder-economic__section">
                                <h2 className="mortgage-request-holder-economic__font-bold">
                                    <FormattedText value="mortgageRequestHolderEconomic-subtitleHeader" />
                                </h2>
                                <p className="mortgage-request-holder-economic__intro">
                                    <FormattedText value="mortgageRequestHolderEconomic-confirmData" />
                                </p>
                            </div>
                            <div className="mortgage-request-holder-economic__section">
                                <div className="mortgage-request-holder-economic__section-field">
                                    <div className="mortgage-request-holder-economic__amount">
                                        <AmountInput
                                            name="ingresosNetos"
                                            label={formatText('mortgageRequestHolderEconomic-labelIngresosNetos')}
                                            callback={this.setFieldValue}
                                            error={!this.state.ingresosNetosValid}
                                            errorMsg={validMessages.isRequired}
                                            amount={this.state.ingresosNetos}
                                            maxFractionLength={2}
                                            showBlurZero
                                            disabled={isApprovedDataProprietor || hasOperationProcessId }
                                            language={this.language}

                                        />
                                    </div>
                                    <div className="mortgage-request-holder-economic__currency-symbol">
                                        {currencyFormatted}
                                    </div>
                                </div>
                            </div>
                            <div className="mortgage-request-holder-economic__section">
                                <div className="mortgage-request-holder-economic__section-field">
                                    <div className="mortgage-request-holder-economic__section-field--select">
                                        <OKSelect
                                            label={formatText('mortgageRequestHolderEconomic-labelRegimenInmueble')}
                                            name="regimenInmueble"
                                            options={regimenInmuebleOptions}
                                            value={this.state.regimenInmueble}
                                            clearable={false}
                                            searchable={false}
                                            onChange={this.handleChangeRegimenInmueble}
                                            errorState={!this.state.regimenInmuebleValid}
                                            errorMessage={validMessages.isRequired}
                                            disabled={isApprovedDataProprietor || hasOperationProcessId }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={montlyFeeContainerClasses}>
                                <div className="mortgage-request-holder-economic__section-field">
                                    <div className="mortgage-request-holder-economic__amount">
                                        <AmountInput
                                            name="cuotaMensualAlquiler"
                                            label={formatText('mortgageRequestHolderEconomic-labelCuotaMensualAlquiler')}
                                            optionalElement={helpToolTipCuotaMensualAlquiler}
                                            callback={this.setFieldValue}
                                            amount={this.state.cuotaMensualAlquiler}
                                            showBlurZero
                                            disabled={isApprovedDataProprietor || hasOperationProcessId }
                                            language={this.language}
                                        />
                                    </div>
                                    <div className="mortgage-request-holder-economic__currency-symbol">
                                        {currencyFormatted}
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="mortgage-request-holder-economic__section">
                                <div className="row">
                                    <div className="col-md-12">
                                        <h2 className="mortgage-request-holder-economic__font-bold">
                                            <FormattedText value="mortgageRequestHolderEconomic-labelAnotherLoans" />
                                        </h2>
                                        <p className="mortgage-request-holder-economic__intro">
                                            {inforAnotherLoans}
                                        </p>
                                    </div>
                                </div>
                                {otherLoansContent}
                                {anotherLoanContent}
                            </div>
                            {
                                ffShowDocument &&
                                <div className="irpf-section">
                                    <hr />
                                    <div className="mortgage-request-holder-economic__section">
                                        <h2>{formatText('mortgageRequestHolderEconomic-titleIrpf')}</h2>
                                        {irpfSection}
                                    </div>
                                    {isBuildAutonomoContent}
                                    <MortgageRequestGoToDocCenter marginBottom />
                                    <div className="mortgage-request-holder-economic__important-message">
                                        <FormattedText value="mortgageRequestHolderEconomic-importantLabel" className="mortgage-request-holder-economic__important-message--label" />
                                        <FormattedText value="mortgageRequestHolderEconomic-importantMessage" />
                                    </div>
                                </div>
                            }
                            <hr />
                            <div className="row">
                                <div className={ffClassHideDoc}>
                                    <a
                                        href="#"
                                        className="ok-link"
                                        onClick={this.handleCancelChangeEconomicData}
                                    >
                                        {formatText('mortgageRequestHolderEconomic-returnLink')}
                                    </a>
                                </div>
                                {
                                    ffShowDocument &&
                                    <div className="col-md-4">
                                        <div className="pull-right">
                                            <OKButton
                                                modifier="ghost"
                                                disabled={saveDisabled || isApprovedDataProprietor}
                                                onClick={evt => this.handleSave(evt, false)}
                                                loading={saving}
                                            >
                                                {formatText('mortgageRequestHolderEconomic-saveDraftButton')}
                                            </OKButton>
                                        </div>
                                    </div>
                                }
                                <div className="col-md-3">
                                {   
                                    !hasOperationProcessId && (
                                        <OKButton
                                            modifier="primary"
                                            disabled={this.state.ingresosNetos === 0 || saveDisabled || isApprovedDataProprietor}
                                            onClick={evt => this.handleSave(evt, true)}
                                            loading={saving}
                                        >
                                            {formatText('mortgageRequestHolderEconomic-saveButton')}
                                        </OKButton>
                                    )
                                }
                                </div>
                            </div>
                        </ContentBox>
                    </div>
                    <div id="mortgageRequestHolderEconomicPanelRight" className=" col-md-4">
                        { this.buildManagerDocumentation() }
                        <ContentBox customClassName="mortgage-request-holder-economic__margin">
                            <h2 className="mortgage-request-holder-economic__block-title">
                                {formatText('mortgageRequestHolderEconomic-titleIrpfInfo')}
                            </h2>
                            <p>{formatText('mortgageRequestHolderEconomic-infoIrpfInfo')}</p>
                            <OKLink
                                modifier="editorial"
                                to={sedeElectronicaAgenciaTributariaLink}
                                target="_blank"
                            >
                                <FormattedText value="mortgageRequestHolderEconomic-linkSEAT" />
                            </OKLink>
                        </ContentBox>
                        {
                            ffShowDocument &&
                            <ContentBox customClassName="mortgage-request-holder-economic__margin">
                                <h2 className="mortgage-request-holder-economic__block-title">{formatText('mortgageRequestHolderEconomic-titleCsvInfo')}</h2>
                                <div className="cea-info"></div>
                            </ContentBox>
                        }
                        {isBuildAutonomoInfo}
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestHolderEconomic.propTypes = {
    history: PropTypes.object.isRequired,
    mortgageRequestState: PropTypes.object,
    isHolder: PropTypes.bool,
    holderId: PropTypes.string,
    obcd: PropTypes.string,
    holderEconomic: PropTypes.object,
    holderEconomicEdit: PropTypes.object,
    requestHolderEconomic: PropTypes.func,
    requestHolderWork: PropTypes.func,
    editHolderEconomic: PropTypes.func,
    editHolderEconomicIRPF: PropTypes.func,
    editHolderEconomic130: PropTypes.func,
    deleteOtherLoan: PropTypes.func,
    addFile: PropTypes.func,
    requestEconomicFlag: PropTypes.func,
    workData: PropTypes.object,
    summaryDocsState: PropTypes.object,
    docCenterState: PropTypes.object,
    resetHolderEconomicState: PropTypes.func,
    resetWorkDataState: PropTypes.func,
    requestSummaryDocumentation: PropTypes.func,
    requestDocuments: PropTypes.func,
    requestOtherLoans: PropTypes.func,
    holderNum: PropTypes.string.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    holdersDataValidation: PropTypes.object,
};

module.exports.MortgageRequestHolderEconomic = connect(
    state => ({
        holderEconomic: state.mortgageRequestHolderEconomic,
        holderEconomicEdit: state.mortgageRequestHolderEconomicEdit,
        mortgageRequestState: state.mortgageRequestState,
        workData: state.mortgageRequestWorkData,
        summaryDocsState: state.mortgageRequestSummaryDocumentation,
        docCenterState: state.mortgageRequestDocumentationCenter,
        immFlagBasedFeatures: state.flagBasedFeatures,
        holdersDataValidation: state.mortgageHoldersDataValidation,
        dataProprietors: state.mortgageRequestDataProprietor,
    }), {
        resetHolderEconomicState: holderEconomicActions.reset,
        resetWorkDataState: mortgageRequestWorkData.reset,
        requestHolderEconomic: holderEconomicActions.requestHolderEconomic,
        requestHolderWork: mortgageRequestWorkData.requestHolderWork,
        editHolderEconomic: holderEconomicActions.editHolderEconomic,
        editHolderEconomicIRPF: holderEconomicActions.editHolderEconomicIRPF,
        editHolderEconomic130: holderEconomicActions.editHolderEconomic130,
        deleteOtherLoan: holderEconomicActions.deleteOtherLoan,
        addFile: holderEconomicActions.addFile,
        requestEconomicFlag: holderEconomicActions.requestEconomicFlag,
        requestSummaryDocumentation: dataProprietorActions.requestSummaryDocumentation,
        requestDocuments: documentActions.getDocument,
        requestOtherLoans: holderEconomicActions.requestOtherLoans,
        requestDataProprietor: dataProprietorActions.requestDataProprietor,
    })(withRouter(MortgageRequestHolderEconomic));
